import React, { useState, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import About from "../layouts/About";
import "../styles/about-animate.css";
import styles from "../styles/home.module.css";

const AboutComponent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.7 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup the observer
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="about-transition"
      >
        <div className={styles["base-content-left"]}>
          <p className={styles["title"]}>About</p>
          <p className={styles["description"]}>
            HUMAN Protocol and Signa X have partnered to launch one of the
            world's first game challenge creator platforms for Web3. Through
            this partnership, game developers can create specific game
            challenges for their own ecosystems, and the Signa-X ecosystem, and
            use HUMAN Protocol to initiate payouts as rewards to their game
            players.
          </p>
        </div>
      </CSSTransition>
    </div>
  );
};
export default AboutComponent;
